import * as THREE from "three";
import { defineModel, type Part } from "../../lib";

// Modern Living kit — a wall-mounted towel bar authored at mounting height:
// two steel brackets against the wall at z = 0, a steel bar at y = 1.05 and one
// folded blue-grey towel hanging over the bar.
const STEEL = "#aab2b8";
const TOWEL = "#8a9aa8";

export const towelRack = defineModel({
  id: "towel-rack",
  batchId: "modern",
  name: "Towel rack",
  tags: ["modern", "interior", "fixture", "bathroom", "towel", "wall-mounted"],
  summary: "A wall-mounted steel towel bar with a folded blue-grey towel.",
  tiles: { w: 1, h: 1 },
  footprint: 0.6,
  parts(): Part[] {
    return [
      // wall brackets
      { geometry: new THREE.BoxGeometry(0.03, 0.03, 0.09), color: STEEL, position: [-0.265, 1.05, 0.045] },
      { geometry: new THREE.BoxGeometry(0.03, 0.03, 0.09), color: STEEL, position: [0.265, 1.05, 0.045] },
      // steel bar along X
      {
        geometry: new THREE.CylinderGeometry(0.013, 0.013, 0.56, 8),
        color: STEEL,
        position: [0, 1.05, 0.09],
        rotation: [0, 0, Math.PI / 2],
      },
      // folded towel over the bar: top fold, front drape, back drape
      { geometry: new THREE.BoxGeometry(0.3, 0.035, 0.11), color: TOWEL, position: [0, 1.075, 0.09] },
      { geometry: new THREE.BoxGeometry(0.3, 0.34, 0.03), color: TOWEL, position: [0, 0.91, 0.13] },
      { geometry: new THREE.BoxGeometry(0.3, 0.27, 0.03), color: TOWEL, position: [0, 0.945, 0.05] },
    ];
  },
  animations: [],
});
